import React, { Component } from 'react';
import { sanitize } from 'utils/validation';
import MODAL from 'constants/modals';
import LoadingWidget from 'components/LoadingWidget';
import propTypes from './taxesModalContentPropTypes';

class TaxesModalContent extends Component {
  static propTypes = propTypes;

  render() {
    const { taxesCopy } = this.props;

    return taxesCopy ? (
      <div
        id={`${MODAL.RENTAL_DETAILS_TAXES_FEES_MODAL}_desc`}
        className='modal-themed__section modal-themed__gbo-content'
        dangerouslySetInnerHTML={sanitize(taxesCopy)}
      />
    ) : (
      <LoadingWidget />
    );
  }
}

export default TaxesModalContent;
